/* Package JSON Import will be here */
import { sortBy, reverse } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject, errorToast } from "utilities/utils";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
// import { getAppGuidanceApi } from "services/common/appGuidance";
/* Project Import will be here */

export const types = {
    APP_GUIDANCE_REQUEST: "appGuidance/APP_GUIDANCE_REQUEST",
    APP_GUIDANCE_SUCCESS: "appGuidance/APP_GUIDANCE_SUCCESS",
    APP_GUIDANCE_FAILURE: "appGuidance/APP_GUIDANCE_FAILURE",
    APP_GUIDANCE_FILTER_SUCCESS: "appGuidance/APP_GUIDANCE_FILTER_SUCCESS",
    APP_GUIDANCE_SORT_SUCCESS: "appGuidance/APP_GUIDANCE_SORT_SUCCESS"
};

const initialState = {
    isLoading: false,
    error: null,
    data: [],
    filteredData: [],
    appGuidanceIsLoading:false
};

export const appGuidance = (state = initialState, action) => {
    switch (action.type) {
        case types.APP_GUIDANCE_REQUEST: {
            return { ...state, isLoading: true ,appGuidanceIsLoading:true};
        }
        case types.APP_GUIDANCE_SUCCESS: {
            return { ...state, data: action.payload.data, filteredData: action.payload.data, isLoading: false};
        }
        case types.APP_GUIDANCE_FILTER_SUCCESS: {
            return { ...state, filteredData: action.payload.data,appGuidanceIsLoading:false  };
        }
        case types.APP_GUIDANCE_SORT_SUCCESS: {
            return { ...state, filteredData: action.payload.data };
        }
        case types.APP_GUIDANCE_FAILURE: {
            const { error } = action.payload;
            return { ...state, isLoading: false,appGuidanceIsLoading:false, error };
        }
        default:
            return state;
    }
};

export const searchAppGuidance = (searchText) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.APP_GUIDANCE_REQUEST });

        let data = getState().appGuidance.data

        let filteredData = data.filter((item) =>
            item.Title.toLowerCase().includes(searchText.toLowerCase())
        );

        dispatch({ type: types.APP_GUIDANCE_FILTER_SUCCESS, payload: { data: filteredData } });

    };
};

export const sortAppGuidance = (sortType) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.APP_GUIDANCE_REQUEST });
        let data = getState().appGuidance.filteredData

        /* Default name asc sorting */
        let sortData = sortBy(data, o => { return o.Title });

        /* If sorting specify name desc */
        if (sortType === Constants.NAME_DESC)
            data = reverse(sortData);
        else {
            data = sortData;
        }

        dispatch({ type: types.APP_GUIDANCE_SORT_SUCCESS, payload: { data } });
    };
};

export const getAppGuidance = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.APP_GUIDANCE_REQUEST });
        try {
            // const response = await getAppGuidanceApi();
            let data = [];

            dispatch({ type: types.APP_GUIDANCE_SUCCESS, payload: { data } });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.APP_GUIDANCE_FAILURE));
        }
    };
};

const promiseCatchBlock = (error: any, type: string) => {
    return (dispatch) => {
        /* Extract the error message and error code from the response object */
        const { message, errorCode } = getErrorObject(error);

        dispatch({
            type: type,
            payload: { error: message }
        });

        /* If error code is exist show the error code message or show the error message returned by the API request */
        if (errorCode !== "")
            dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
        else
            errorToast({ content: message });
    }
};